<div class="file-container">
	<div class="card-header">
		<div class="info">
			<mat-checkbox
				color="primary"
				[checked]="fileSelected"
				class="au-checkbox"
				(change)="selectionChange.emit(file)"
			>
			</mat-checkbox>

			<au-file-name [fileData]="file" [name]="file?.name" (openFile)="openFile.emit()" />
		</div>

		@if (allowDelete) {
			<mat-icon
				class="critical-icon cursor-pointer"
				svgIcon="remove-attachment"
				(click)="deletePressed.emit()"
			></mat-icon>
		}
	</div>

	<div class="file-body">
		<div class="collumn type">
			@if (file.type) {
				<au-document-type [smallFont]="true" [type]="file.type" />
			}
			@if (!file.type) {
				<span>{{ 'document_types_no_document_type' | translate }}</span>
			}
		</div>

		<div class="column classification">
			@if (file?.classificationsV2?.length) {
				<au-expandable-tags
					class="tag"
					[tags]="file.classificationsV2"
					[textMaxWidth]="'150px'"
					[initSize]="1"
				/>
			}
			@if (!file?.classificationsV2?.length) {
				<span>{{ 'not_classified' | translate }}</span>
			}
		</div>

		<div class="column avatar-with-name">
			@if (file.createdBy) {
				<au-avatar-with-name
					nameOnHover="true"
					[data]="file.createdBy"
					[tooltipPrefix]="'created_by' | translate"
				/>
			}

			@if (!file.createdBy) {
				<span>{{ 'no_data' | translate }}</span>
			}
		</div>

		<div class="column date">
			@if (file.created) {
				<span>
					{{ file.created | dateAgo }}
				</span>
			}

			@if (!file.created) {
				<span>{{ 'no_data' | translate }}</span>
			}
		</div>
	</div>
</div>
